import { get } from 'lodash'
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Cache, DataStore } from '@skinsoft/data-store';
import { Proxy } from '@skinsoft/network';

export interface TranslatedString {
    translatedString: Record<string, string | null>;
}

export interface Translation {
    i18nId: string;
    lang: string;
    message: Record<string, any>;
}

export class TranslationDataStore extends DataStore<Translation> {
    public static getInstance() {
        if (!TranslationDataStore.instance) {
            TranslationDataStore.instance = new TranslationDataStore();
        }

        return TranslationDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$translationDataStore = TranslationDataStore.getInstance();
    }

    private static instance: TranslationDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<Translation>) {
        super('/translations', undefined, undefined, proxy, cache);
    }

    public fetchOne(id: string, networkFirst = false) {
        return super.fetchOne(id, false).pipe(
            tap(translation => {
                this.cache.write(`/translations/${id}`, [translation])
            })
        )
    }

    public getMessage(key: string, locale: string): Observable<string> {
        return this.cache.read(`/translations/${locale}`)
            .pipe(
                map(
                    translations => {
                        if (translations && translations[0]) {
                            return get(translations[0].message, key);
                        }
                        return key;
                    }
                )
            );
    }
}
